// assets/globo-sticky-atc-fix.js
// Intercepts sticky ATC clicks and validates Globo Product Options before proceeding

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const stickyButton = e.target.closest(
      'sticky-add-to-cart .sticky-add-to-cart__button'
    );
    if (!stickyButton) return;

    // Find the main product form's ATC button
    const stickyComponent = stickyButton.closest('sticky-add-to-cart');
    if (!stickyComponent) return;

    const productId = stickyComponent.dataset.productId;
    const section = stickyComponent.closest('.shopify-section');
    const mainForm = section?.querySelector(
      `product-form-component[data-product-id="${productId}"] form`
    );
    if (!mainForm) return;

    // Check for unselected required Globo options
    // Globo marks required fields with [data-option-required] or similar
    // Trigger validation by dispatching a submit attempt on the main form
    const unselectedRequired = mainForm.querySelectorAll(
      '.globo-po-option[data-required="true"]:not([data-selected="true"]), ' +
      '[data-gpop-required]:not([data-gpop-selected])'
    );

    if (unselectedRequired.length > 0) {
      e.stopImmediatePropagation();
      e.preventDefault();

      // Scroll to the main form and trigger Globo's own validation UI
      mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Fire a submit event on the form so Globo shows its error messages
      mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      return;
    }
  }, true); // capture phase — runs before the sticky component's handler
});
